module.exports = __webpack_public_path__ + "static/media/43.fb1899cc.png";